import { CircularStockAvailabilityApi } from '../types/api/circular-stock-availability-api';
import { NetworkResponse } from '../types/services/request.types';
import { RequestHandler } from './requestHandler.service';

export class ApigeeCircularStockAvailabilityHandler extends RequestHandler {
  api = {
    target: 'apigee-circular-stock-availability',
    default: 'apigee-default',
  };

  getCircularStockAvailability(
    { url, apiKey, queryParams }: CircularStockAvailabilityApi.GetStockAvailabilityParams,
  ): NetworkResponse<CircularStockAvailabilityApi.GetStockAvailabilityResponse> {
    const params = new URLSearchParams(queryParams);
    const urlWithParams = `${url}?${params}`;

    if (!apiKey) {
      return this.get<CircularStockAvailabilityApi.GetStockAvailabilityResponse>(urlWithParams);
    }

    return this.get<CircularStockAvailabilityApi.GetStockAvailabilityResponse>(
      urlWithParams,
      {
        standardSettings: {
          headers: {
            apikey: apiKey,
          },
        },
      },
    );
  }
}

export const ApigeeCircularStockAvailability = new ApigeeCircularStockAvailabilityHandler();
